export const formatDateDDMMYYYY = (dateString) => {
  if (!dateString) return "";

  let dateObj;
  if (dateString instanceof Date) {
    dateObj = dateString;
  } else {
    const dateStr = dateString.toString().split('.')[0];
    dateObj = new Date(dateStr);
  }

  if (isNaN(dateObj)) return dateString;

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();

  return `${day}/${month}/${year}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "-";

  let dateObj;
  if (dateString instanceof Date) {
    dateObj = dateString;
  } else {
    const dateStr = dateString.toString().split('.')[0];
    dateObj = new Date(dateStr);
  }

  if (isNaN(dateObj.getTime())) return dateString;

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();

  let hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const strHours = String(hours).padStart(2, '0');

  return `${day}/${month}/${year} • ${strHours}:${minutes}:${seconds} ${ampm}`;
};

export const formatTime = (dateString) => {
  if (!dateString) return "";

  let dateObj;
  if (dateString instanceof Date) {
    dateObj = dateString;
  } else {
    const dateStr = dateString.toString().split('.')[0];
    dateObj = new Date(dateStr);
  }

  if (isNaN(dateObj.getTime())) return "";

  let hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, '0');
  const seconds = String(dateObj.getSeconds()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const strHours = String(hours).padStart(2, '0');

  return `${strHours}:${minutes}:${seconds} ${ampm}`;
};
